import { inject, Injectable, PLATFORM_ID} from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY } from 'rxjs';

export type ConsentTypes =
  | 'ad_personalization'
  | 'ad_storage'
  | 'ad_user_data'
  | 'analytics_storage'
  | 'functionality_storage'
  | 'personalization_storage'
  | 'security_storage';

export type ConsentPayload = Partial<{
  [key in ConsentTypes]: 'granted' | 'denied';
}>;

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
      });
    }
  }

  private http = inject(HttpClient);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  public updateConsent(update: ConsentPayload): void {
    if (isPlatformBrowser(this.platformId)) {
      this.gtag('consent', 'update', update);
    }
  }

  public sendUtmTags(tags: {[key: string]: string}): void {
    if (!tags || Object.keys(tags).length < 1) {
      // don't send if empty
      return;
    }

    const url = '/api/util/utm/tags';

    this.http.post(url, tags)
      .pipe(
        retry(2),
        catchError((err: any) => {
          console.error('Error sending UTM tags:', err);
          return EMPTY;
        })
      )
      .subscribe();
  }

  private gtag(..._args: any[]): void {
    if (isPlatformBrowser(this.platformId) && (window as any).dataLayer) {
      // eslint-disable-next-line prefer-rest-params
      (window as any).dataLayer.push(arguments);
    }
  }
}
